import { createContext, useContext, useState } from "react";

type State = {
  isLoginProcessing: boolean;
  setLoginProcessing: (value: boolean) => void;
};

const LoginContext = createContext<State>({
  isLoginProcessing: false,
  setLoginProcessing: () => undefined,
});

export const useLoginProcessing = () => useContext(LoginContext);

type Props = {
  children: React.ReactNode;
};

export const LoginProvider: React.FC<Props> = ({ children }) => {
  const [isLoginProcessing, setLoginProcessing] = useState(false);

  return (
    <LoginContext.Provider value={{ isLoginProcessing, setLoginProcessing }}>
      {children}
    </LoginContext.Provider>
  );
};
